import { Injectable } from '@angular/core';
import { CheapFlightModel } from '@models/cheap-flight.model';
import { BaseResponse } from '@models/common.model';
import { HttpService } from '@services/http.service';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CheapFlightService {
    constructor(private _http: HttpService) {}

    /**
     * Get cheap flight
     *
     * @param {number} id
     * @return {*}  {Observable<CheapFlightModel[]>}
     * @memberof CheapFightService
     */
    public getCheapFlight(): Observable<CheapFlightModel[] | []> {
        return this._http
            .get<BaseResponse<CheapFlightModel[]>>(`CheepFlight/UserViewCheepFlight`)
            .pipe(
                catchError(() => {
                    return of(new BaseResponse<CheapFlightModel[]>({ Data: [] }));
                }),
                map((res) => res.Data || [])
            );
    }
}
